/* Pip & Moon — mobile quick add.

   Context: product cards carry a `.quick` hover panel that pm-base.css hides on
   every touch device, so phones had no add-to-cart control on collection pages.
   This adds an explicit trigger per card and an option-picking bottom sheet.

   It deliberately reuses the theme's existing, proven cart pipeline
   (PM.addItems -> /cart/add.js -> Section Rendering refresh -> openCart) rather
   than posting to the cart itself. No second cart implementation. */
(function () {
  'use strict';

  var PM = window.PM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };

  var sheet = null;
  var backdrop = null;
  var current = null;   /* parsed card payload */
  var selected = {};    /* { optionPosition: value } */
  var opener = null;    /* trigger element, for focus restore */

  function money(cents) {
    if (typeof window.PMformatMoney === 'function') return window.PMformatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function refs() {
    sheet = $('#qaSheet');
    backdrop = $('[data-qa-backdrop]');
    return !!sheet;
  }

  /* ---------------- variant matching ---------------- */

  /* A variant satisfies `sel` when every chosen option position matches. */
  function matches(variant, sel) {
    for (var pos in sel) {
      if (!Object.prototype.hasOwnProperty.call(sel, pos)) continue;
      if (variant.o[Number(pos) - 1] !== sel[pos]) return false;
    }
    return true;
  }

  function variantFor(sel) {
    for (var i = 0; i < current.v.length; i++) {
      if (matches(current.v[i], sel)) return current.v[i];
    }
    return null;
  }

  /* Is `value` at `pos` reachable in stock, given the other current choices?
     Lets us strike through sizes that are genuinely unavailable instead of
     letting someone pick one and hit an error at the cart. */
  function valueAvailable(pos, value) {
    var probe = {};
    for (var k in selected) {
      if (Object.prototype.hasOwnProperty.call(selected, k) && Number(k) !== Number(pos)) probe[k] = selected[k];
    }
    probe[pos] = value;
    for (var i = 0; i < current.v.length; i++) {
      if (current.v[i].a && matches(current.v[i], probe)) return true;
    }
    return false;
  }

  function allChosen() {
    for (var i = 0; i < current.o.length; i++) {
      if (!selected[current.o[i].p]) return false;
    }
    return true;
  }

  /* ---------------- rendering ---------------- */

  function renderOptions() {
    var host = $('[data-qa-opts]', sheet);
    host.innerHTML = '';

    current.o.forEach(function (opt) {
      var row = document.createElement('div');
      row.className = 'qa-row';

      var head = document.createElement('div');
      head.className = 'qa-row-head';
      var name = document.createElement('span');
      name.className = 'qa-row-name';
      name.textContent = opt.n;
      var picked = document.createElement('span');
      picked.className = 'qa-row-picked';
      picked.setAttribute('data-qa-picked', String(opt.p));
      picked.textContent = selected[opt.p] || '';
      head.appendChild(name);
      head.appendChild(picked);

      var vals = document.createElement('div');
      vals.className = 'qa-vals';
      vals.setAttribute('role', 'group');
      vals.setAttribute('aria-label', opt.n);

      opt.v.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qa-val';
        b.textContent = v;
        b.setAttribute('data-qa-pos', String(opt.p));
        b.setAttribute('data-qa-value', v);
        b.setAttribute('aria-pressed', selected[opt.p] === v ? 'true' : 'false');
        if (!valueAvailable(opt.p, v)) {
          b.disabled = true;
          b.setAttribute('aria-label', v + ' — sold out');
        }
        vals.appendChild(b);
      });

      row.appendChild(head);
      row.appendChild(vals);
      host.appendChild(row);
    });
  }

  function syncFoot() {
    var add = $('[data-qa-add]', sheet);
    var note = $('[data-qa-note]', sheet);
    var price = $('[data-qa-price]', sheet);
    var variant = allChosen() ? variantFor(selected) : null;

    if (variant) price.textContent = money(variant.p);

    if (!allChosen()) {
      /* Name the option that is still missing — the PDP's failure mode was a
         generic message rendered off-screen, so be specific and keep it here
         next to the button the shopper is about to press. */
      var missing = [];
      current.o.forEach(function (o) { if (!selected[o.p]) missing.push(o.n.toLowerCase()); });
      add.disabled = true;
      /* "your" not "a": option names are merchant-defined ("Shorts", "Top",
         "Bikini Top"), and "Choose a shorts" is not English. "Choose your
         shorts and top" is grammatical for every option name. */
      note.textContent = 'Choose your ' + missing.join(' and ') + ' to continue.';
      return;
    }
    if (!variant || !variant.a) {
      add.disabled = true;
      note.textContent = 'That combination is sold out.';
      return;
    }
    add.disabled = false;
    note.textContent = '';
  }

  function choose(pos, value) {
    if (selected[pos] === value) {
      delete selected[pos];       /* tapping the chosen value clears it */
    } else {
      selected[pos] = value;
    }
    renderOptions();
    syncFoot();
  }

  /* ---------------- open / close ---------------- */

  function open(card, trigger) {
    var holder = $('.card-qa-data', card);
    if (!holder) return false;

    try {
      current = JSON.parse(holder.textContent);
    } catch (err) {
      return false;
    }
    if (!current || !current.v || !current.v.length) return false;

    /* No option to pick (single-variant product): skip the sheet entirely. */
    if (!current.o || !current.o.length) {
      var only = null;
      for (var i = 0; i < current.v.length; i++) { if (current.v[i].a) { only = current.v[i]; break; } }
      if (!only) return false;
      addToCart(only.id, trigger);
      return true;
    }

    if (!refs()) return false;

    selected = {};
    opener = trigger || null;

    var thumb = $('[data-qa-thumb]', sheet);
    if (current.i) {
      thumb.src = current.i;
      thumb.alt = current.t || '';
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
      thumb.removeAttribute('src');
    }
    $('[data-qa-title]', sheet).textContent = current.t || '';
    $('[data-qa-price]', sheet).textContent = money(current.p);
    var details = $('[data-qa-details]', sheet);
    if (details) details.href = current.u || '#';

    renderOptions();
    syncFoot();

    document.documentElement.classList.add('qa-open');
    if (backdrop) { backdrop.classList.add('is-on'); }
    sheet.classList.add('is-on');
    sheet.setAttribute('aria-hidden', 'false');

    /* Focus the dialog itself, NOT the first size button: a focus ring on XS
       reads as "XS is selected", which is the exact confusion this build sets
       out to remove. Keyboard users still tab straight into the size row. */
    try { sheet.focus({ preventScroll: true }); } catch (e) { sheet.focus(); }
    return true;
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-on');
    sheet.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-on');
    document.documentElement.classList.remove('qa-open');
    if (opener) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }

  /* ---------------- add ---------------- */

  function addToCart(variantId, trigger) {
    if (trigger) trigger.setAttribute('aria-busy', 'true');

    function done() {
      if (trigger) trigger.removeAttribute('aria-busy');
    }

    var pm = window.PM || {};
    if (typeof pm.addItems === 'function') {
      /* addItems already refreshes the cart UI, toasts and opens the drawer. */
      var p = pm.addItems([{ id: Number(variantId), quantity: 1 }]);
      if (p && typeof p.then === 'function') { p.then(done, done); } else { done(); }
      return;
    }

    /* Fallback only if pm-theme.js failed to load: post the add, then do a full
       reload so the cart is never silently wrong. */
    var rootUrl = (pm.routes && pm.routes.root) ? pm.routes.root.replace(/\/$/, '') : '';
    fetch(rootUrl + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = (pm.routes && pm.routes.cart) || '/cart';
    }).catch(done);
  }

  /* ---------------- events ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var trigger = e.target.closest('[data-qa-open]');
    if (trigger) {
      var card = trigger.closest('.card, [data-qa-card]');
      if (card) {
        e.preventDefault();
        open(card, trigger);
      }
      return;
    }

    if (e.target.closest('[data-qa-close]') || e.target.closest('[data-qa-backdrop]')) {
      e.preventDefault();
      close();
      return;
    }

    var val = e.target.closest('.qa-val');
    if (val && !val.disabled && sheet && sheet.contains(val)) {
      e.preventDefault();
      choose(val.getAttribute('data-qa-pos'), val.getAttribute('data-qa-value'));
      return;
    }

    var add = e.target.closest('[data-qa-add]');
    if (add && !add.disabled && current) {
      e.preventDefault();
      var variant = variantFor(selected);
      if (!variant || !variant.a) { syncFoot(); return; }
      var btn = opener;
      close();
      addToCart(variant.id, btn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('is-on')) close();
  });
})();
